import React from "react";
import { Link } from "react-router-dom";

import logo from "../images/rrlogoicon.png";

import Nav from "./Nav";

const Header = ({ navOptions, reserve, navigateToRoute }) => {
  return (
    <div className="bg-white text-bigblue border-gray-200 border-b sticky top-0 left-0 right-0 w-full flex items-center justify-between flex-wrap p-4 z-[5]">
      <Link
        className="hover:brightness-125"
        to="/"
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <img
          src={logo}
          alt="Our Rest and Relax Logo"
          width="50"
          height="50"
          title="Go Home"
        />
      </Link>
      <Nav
        navOptions={navOptions}
        reserve={reserve}
        navigateToRoute={navigateToRoute}
      />
    </div>
  );
};

export default Header;
